var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTicketColor = function SvgTicketColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4602 20.5903V7.19007L15.4698 7.17228V5.17004C15.4698 4.59451 15.6984 4.04255 16.1054 3.63559C16.5124 3.22863 17.0643 3 17.6399 3H7.09008C6.65062 3 6.21546 3.08671 5.80957 3.25519C5.40369 3.42367 5.03505 3.67058 4.72476 3.9818C4.41448 4.29301 4.16866 4.6624 4.00139 5.06879C3.83413 5.47518 3.7487 5.9106 3.75001 6.35006V20.5903H15.4602Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6334 3H17.8941C18.4712 3 19.0246 3.22925 19.4327 3.63731C19.8407 4.04537 20.07 4.59881 20.07 5.1759V12.0245H15.4575V5.1759C15.4575 4.59881 15.6867 4.04537 16.0948 3.63731C16.5029 3.22925 17.0563 3 17.6334 3V3Z",
    fill: "#33DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.75H7V7.25H11.5V8.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 11.75H7V10.25H11.5V11.75Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicketColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ticket-color.9c46ec514e85b80da45a227348aeb939.svg";